export default {
  /**
   * @description 只支持PC，不是PC提示使用电脑打开或者使用APP端学习
   * @returns Boolean
   */
  isPC: function () {
    let ua = navigator.userAgent.toLowerCase()
    let client = ['android', 'iphone', 'phone', 'ipad', 'ipod', 'mobile']
    let ispc = true

    for (let i = 0; i < client.length; i++) {
      if (ua.indexOf(client[i]) > -1) {
        ispc = false
        break
      }
    }

    return ispc
  },
  /**
   * @description 兼容Chrome,包含chrome
   * @returns Boolean
   */
  isChrome: function () {
    let ua = navigator.userAgent.toLowerCase()
    return ua.indexOf('chrome') > -1
  },
  /**
   * @description 最低版本检测
   * @returns Boolean
   */
  chromeVersion: function () {
    let ua = navigator.userAgent.toLowerCase()
    let paltforms = ua.split(' ')
    let supportVerison = 74 // 支持的最低版本
    let isNotSuppoert = true

    if (ua.indexOf('chrome') < 0) {
      isNotSuppoert = false
    } else {
      for (let i = 0; i < paltforms.length; i++) {

        if (paltforms[i] && paltforms[i].indexOf('chrome') > -1) {
          let version = paltforms[i].split('/')[1]
          if (!version) {// 空版本，返回
            isNotSuppoert = false
            break
          } else {
            version = version.split('.')[0]
            if (isNaN(version)) { // 不是数字
              isNotSuppoert = false
              return
            }

            if (version < supportVerison) { // 低于版本
              isNotSuppoert = false
              return
            }
          }
        }
      }
    }

    return isNotSuppoert
  }
}
